/**
 * The access token lives in memory only (never localStorage); the refresh token
 * is an httpOnly cookie the browser manages. Session-expiry listeners let the
 * auth layer sign out and clear caches when a refresh ultimately fails.
 */
let accessToken: string | null = null;
const expiryListeners = new Set<() => void>();

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function onSessionExpired(listener: () => void): () => void {
  expiryListeners.add(listener);
  return () => expiryListeners.delete(listener);
}

export function notifySessionExpired(): void {
  expiryListeners.forEach((listener) => listener());
}
